<template>
  <list-item
    :booking="booking"
    :link="{ name: 'requests.show', params: { id: booking.id } }"
  >
    <title>
      <span>{{ bookingName }}</span>
      <span v-if="$userIsAdmin"> - {{ bookingDateCreated }}</span>
    </title>

    <price>
      {{ booking.budget_per_star | currency(booking.currency) }}
    </price>

    <template v-slot:status>
      <div class="spacer-b-2" v-if="booking.urgent" >
        <span class="label label-danger">Urgent</span>
      </div>
    </template>

  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'

export default {
  mixins: [helpers],
  components: {
    ListItem
  },
  props: {
    booking: {
      required: true,
      type: Object
    }
  }
}
</script>
